import styled from '@emotion/styled';
import { Input, InputNumber, InputNumberProps, InputProps } from 'antd';
import { FC, memo, useEffect, useState } from 'react';
type ExtraProps = {
  isWarning?: boolean;
};

type InputTableNumberProps = InputNumberProps & {
  inputType?: 'number';
} & ExtraProps;
type InputTableTextProps = InputProps & { inputType: 'text' } & ExtraProps;
type InputTableProps = InputTableNumberProps | InputTableTextProps;

const getColor = (isWarning?: boolean) => (isWarning ? '#F97316' : undefined);

const StyledInputNumber = styled(InputNumber)<ExtraProps>`
  &.ant-input-number {
    .ant-input-number-input {
      color: ${({ isWarning }) => getColor(isWarning)};
    }
  }
`;

export const InputTable: FC<InputTableProps> = memo(
  ({ value, inputType = 'number', ...rest }) => {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
      if (value !== localValue) {
        setLocalValue(value);
      }
    }, [value]);

    if (inputType === 'text') {
      const onChange: InputProps['onChange'] = (e) => {
        setLocalValue(e.target.value);
        (rest as InputProps).onChange?.(e);
      };

      return (
        <Input
          {...(rest as InputProps)}
          onChange={onChange}
          value={localValue as InputProps['value']}
        />
      );
    }

    const onChange: InputNumberProps['onChange'] = (newValue) => {
      setLocalValue(newValue);
      (rest as InputNumberProps).onChange?.(newValue);
    };

    return (
      <StyledInputNumber
        {...(rest as InputNumberProps)}
        onChange={onChange}
        value={localValue as InputNumberProps['value']}
      />
    );
  }
);
